import request from '@/utils/request'
// 获取短信列表
const getSmsList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg/list`,
        params,
        method: 'get'
    })
}
// 获取短信列表数量
const getSmsListCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/count`,
        params,
        method: 'get'
    })
}
// 获取短信记录
const getSmsRecordList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record`,
        params,
        method: 'get'
    })
}
// 获取短信记录数量
const getSmsRecordCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/count`,
        params,
        method: 'get'
    })
}
// 获取短信模板内容
const getSmsTemplate = (id) => {
    return request({
        url: `/gathering/meeting/${id}/msg/tmpl/list`,
        method: 'get'
    })
}
// 重新发送/批量发送
const againSend = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/send`,
        method: 'post',
        data: params
    })
}
// 获取当前用户的手机号
const getUserPhones = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/phones`,
        method: 'get',
        params
    })
}
// 短信群发
const groupSMS = (meetingId, id) => {
    return request({
        url: `/gathering/meeting/${meetingId}/msg/${id}/sendAll`,
        method: 'post'
    })
}
// 单条短信发送
const singleSMS = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg/send`,
        method: 'post',
        data: params
    })
}
// 编辑短信通知
const editSMS = (meetingId, id, params) => {
    return request({
        url: `/gathering/meeting/${meetingId}/msg/${id}`,
        method: 'put',
        data: params
    })
}
// 获取会议管理人
const getMeetingManager = (id) => {
    return request({
        url: `/gathering/meeting/${id}/manager`,
        method: 'get'
    })
}
// 获取excel文件手机号码
const getPhonesExcel = (meetingId,fileId) => {
    return request({
        url: `/gathering/meeting/${meetingId}/lianlu_msg/get_phones_excel/${fileId}`,
        method: 'get'
    })
}
// 上传excel文件手机号码
const uploadPhonesExcel = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/lianlu_msg/get_phones_excel`,
        method: 'post',
        data: params
    });
}
// 发送自定义短信
const createNormalTask = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/lianlu_msg/create_normal_task`,
        method: 'post',
        data: params
    });
}
// 发送模板短信
const createTmplMsgTask = (meeting_id, params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/create_tmpl_msg_task`,
        method: 'post',
        data: params
    });
}
// 获取会议短信模板
const getMeetingLianluMsg = (meetingId) => {
    return request({
        url: `/gathering/meeting/${meetingId}/lianlu_msg/get_meeting_lianlu_msg`,
        method: 'get'
    })
}
// 修改配置参数
const setLianluMsgParamJson = (meeting_id, meeting_lianlu_msg_id, params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/${meeting_lianlu_msg_id}/set_lianlu_msg_param_json`,
        method: 'post',
        data: params
    })
}
// 获取新短信列表
const getTaskList = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_list`,
        method: 'get',
		params
    })
}
// 获取新短信列表数量
const getTaskListCount = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_list_count`,
        method: 'get',
		params
    })
}
// 获取短信任务详情列表
const getTaskDetailsList = (meeting_id,task_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_details_list/${task_id}`,
        method: 'get',
		params
    })
}
// 获取短信任务详情列表
const getTaskDetailsListCount = (meeting_id,task_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_details_list_count/${task_id}`,
		params,
        method: 'get',
		
    })
}

// 获取短信任务详情统计数量
const getTaskDetailsStatistics = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_details_statistics`,
        method: 'get',
		params
    })
}
// 重发
const lianluMsgResend = (meeting_id,id) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/resend/${id}`,
        method: 'get',
    })
}
// 单发
const singleSend = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/single_send`,
		params,
        method: 'get',
    })
}

export {
    getSmsList,
    getSmsRecordList,
    getSmsTemplate,
    againSend,
    getSmsListCount,
    getSmsRecordCount,
    getUserPhones,
    getMeetingManager,
    groupSMS,
    singleSMS,
    editSMS,
	getPhonesExcel,
	uploadPhonesExcel,
	createNormalTask,
	getMeetingLianluMsg,
	setLianluMsgParamJson,
	createTmplMsgTask,
	getTaskList,
	getTaskListCount,
	getTaskDetailsList,
	getTaskDetailsListCount,
	getTaskDetailsStatistics,
	lianluMsgResend,
	singleSend
}